import { HttpMethods } from "@/react/http";
import { customerBaseApi } from "@/react/services/api";

import URLBuilder from "./urlBuilder";

const QUEUES_CACHE_TAG = "QUEUES";

const buildMutation = (method, params) => {
  const tenantName = params.tenantName;
  const inboundQueues = params?.inboundQueues ?? [];
  return {
    method,
    url: URLBuilder.InboundQueues(tenantName),
    body: inboundQueues,
  };
};

export const queuesApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getQueuesByMediaType: build.query({
      query: (params) => {
        const tenantName = params.tenantName;
        const mediaTypes = params?.mediaTypes ?? null;
        return {
          method: HttpMethods.GET,
          url: URLBuilder.GetQueuesByMediaTypes(tenantName, mediaTypes),
        };
      },
      providesTags: [QUEUES_CACHE_TAG],
    }),
    deleteQueues: build.mutation({
      query: (params) => {
        const tenantName = params.tenantName;
        const queueIds = params?.queueIds ?? [];
        return {
          method: HttpMethods.POST,
          url: URLBuilder.DeleteQueues(tenantName),
          body: queueIds,
        };
      },
      invalidatesTags: [QUEUES_CACHE_TAG],
    }),
    createInboundQueues: build.mutation({
      query: (params) => buildMutation(HttpMethods.POST, params),
      invalidatesTags: [QUEUES_CACHE_TAG],
    }),
    updateInboundQueues: build.mutation({
      query: (params) => buildMutation(HttpMethods.PUT, params),
      invalidatesTags: [QUEUES_CACHE_TAG],
    }),
  }),
});

export const {
  useGetQueuesByMediaTypeQuery,
  useDeleteQueuesMutation,
  useCreateInboundQueuesMutation,
  useUpdateInboundQueuesMutation,
} = queuesApi;
